import { Modal, Space } from "antd"
import ImagePicker from "../attachments/ImagePicker"
import { useEffect, useState } from "react"
import IconAndTextButton from "../IconAndTextButton"
import { faArrowLeft, faBan, faCheck } from "@fortawesome/pro-solid-svg-icons"

export type Props = {
  isOpen: boolean
  customerId: number
  propertyId: number
  priorSelectedAttachmentId?: string | null
  onCancel: () => void
  onSelect: (attachmentId: string) => void
  onClear: () => void
}

const PropertyPhotoModal = ({isOpen, customerId, propertyId, priorSelectedAttachmentId, onCancel, onSelect, onClear}: Props) => {
  const [selectedAttachmentId, setSelectedAttachmentId] = useState<string | null | undefined>(priorSelectedAttachmentId)

  useEffect(() => {
    setSelectedAttachmentId(priorSelectedAttachmentId)
  }, [priorSelectedAttachmentId])

  return <Modal
    title="Select an attachment to make property profile photo"
    open={isOpen}
    onCancel={onCancel}
    width={950}
    footer={<Space>
      <IconAndTextButton icon={faArrowLeft} text="Close" onClick={() => onCancel()} />
      <IconAndTextButton danger type="primary" icon={faBan} text="Clear Photo" onClick={() => onClear()} />
      <IconAndTextButton type="primary" icon={faCheck} text="Select Primary Photo" onClick={() => onSelect(selectedAttachmentId ?? '')} disabled={selectedAttachmentId === undefined} />
    </Space>}
  >
    <div style={{width: '900px', maxHeight: '70vh', overflowY: 'auto'}}>
      <ImagePicker
        customerId={customerId}
        propertyId={propertyId}
        onAttachmentSelected={setSelectedAttachmentId}
        selectedAttachmentId={selectedAttachmentId}
      />
    </div>
  </Modal>
}

export default PropertyPhotoModal